"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allSettled = exports.allSettledPromise = void 0;
const effects_1 = require("redux-saga/effects");
const OK = 'OK';
const KO = 'KO';
function* allSettledPromise({ promise, payload, ep }) {
    try {
        return { resp: yield (0, effects_1.call)(promise, payload), payload, status: OK, ep };
    }
    catch (err) {
        return { resp: err, payload, status: KO, ep }; // **
    }
}
exports.allSettledPromise = allSettledPromise;
function* allSettled({ promisesConfig, context }) {
    return yield (0, effects_1.all)(Object.keys(promisesConfig).map((entry) => (0, effects_1.call)(allSettledPromise, {
        promise: promisesConfig[entry].promise,
        payload: {
            data: promisesConfig[entry].payload,
            context,
        },
        ep: promisesConfig[entry].ep,
    })));
}
exports.allSettled = allSettled;
exports.default = allSettled;
//# sourceMappingURL=index.js.map